module.exports = __webpack_public_path__ + "static/media/appstore-6d.6c303cc4.png";